import moment from 'moment';

const BatchJobListColumns = [
  {
    title: 'Batch ID',
    dataIndex: 'id',
    width: 200,
    slot: 'batchJobId',
    sorter: (a, b) => (a.id || '').localeCompare(b.id || ''),
  },
  {
    title: 'Job Type',
    dataIndex: 'job_type',
    width: 200,
    sorter: (a, b) => (a.job_type || '').localeCompare(b.job_type || ''),
  },
  {
    title: 'Date/Time Added',
    dataIndex: 'started_at',
    slot: 'started_at',
    width: 250,
    sorter: (a, b) => moment(a.started_at).diff(moment(b.started_at)),
  },
  {
    title: 'Batch Status',
    dataIndex: 'status',
    width: 200,
    slot: 'status',
    sorter: (a, b) => (a.status || '').localeCompare(b.status || '')
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

const BatchJobDetailColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 100
  },
  {
    title: 'Baseline screenshot',
    dataIndex: 'batchJobBaselineScreenShot',
    width: 300,
    slot: 'batchJobBaselineScreenShot'
  },
  {
    title: 'URL',
    dataIndex: 'webPageName',
    width: 250,
    slot: 'webPage',
    sorter: (a, b) => (a.webPageName || '').localeCompare(b.webPageName || '')
  },
  {
    title: 'Baseline Status',
    dataIndex: 'batchJobBaselineStatus',
    width: 180,
    slot: 'status',
    sorter: (a, b) => (a.batchJobBaselineStatus || '').localeCompare(b.batchJobBaselineStatus || '')
  },
  {
    title: 'Progress',
    dataIndex: 'batchJobBaselineProgress',
    width: 200,
    slot: 'progress',
    sorter: (a, b) => +a.batchJobBaselineProgress - +b.batchJobBaselineProgress
  }
];

export { BatchJobListColumns, BatchJobDetailColumns };
